<template>
  <Attachments
    :label="$lang.attachments"
    uploaderName="center_execute"
    resourceName="center_execute"
    smBreakItem="6"
    lgBreakItem="6"
    wrapperClass="center-execute-attachments"
    :shouldEditableAttachmentType="false"
    :getListMethod="handleGetAttachments"
    :createMethod="handleCreateAttachment"
    :updateMethod="handleUpdateAttachment"
    :deleteMethod="handleDeleteAttachment"
  />
</template>
<script>
import { Attachments } from "@/components/re-design";
import {
  centerExecuteListGetAttachments,
  centerExecuteListCreateAttachment,
  centerExecuteListUpdateAttachment,
  centerExecuteListDeleteAttachment,
} from "@/modules/kanoon/services";
import { generateError } from "@/shared/utils";
import { inject, computed } from "vue";
import { pathOr } from "ramda";
export default {
  components: { Attachments },
  setup() {
    const centerExecuteData = inject("CENTER_EXECUTE_DATA");
    const centerExecuteCode = computed(() =>
      pathOr(null, ["code"], centerExecuteData.value)
    );
    const centerExecuteId = computed(() =>
      pathOr(null, ["id"], centerExecuteData.value)
    );

    const handleGetAttachments = async (page, perPage) => {
      try {
        const response = await centerExecuteListGetAttachments(
          centerExecuteCode.value,
          page,
          perPage
        );
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleCreateAttachment = async (tempFiles) => {
      try {
        const response = await centerExecuteListCreateAttachment(
          centerExecuteCode.value,
          tempFiles
        );
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleUpdateAttachment = async (
      attachmentCode,
      attachmentTypeId,
      attachmentCaption
    ) => {
      try {
        const response = await centerExecuteListUpdateAttachment({
          centerExecuteCode: centerExecuteCode.value,
          attachmentCode,
          attachmentCaption,
        });
        return response;
      } catch (error) {
        generateError(error);
      }
    };
    const handleDeleteAttachment = async (attachmentCode) => {
      try {
        const response = await centerExecuteListDeleteAttachment(
          centerExecuteCode.value,
          attachmentCode
        );
        return response;
      } catch (error) {
        generateError(error);
      }
    };

    // return data to be used in template
    return {
      handleGetAttachments,
      handleCreateAttachment,
      handleUpdateAttachment,
      handleDeleteAttachment,
    };
  },
};
</script>
